import { ProduktDTO } from "~app/common/models/produkt/ProduktDTO";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ProduktDetailTexts } from "../produkt-detail.texts";

export class ProduktDetailHeaderValidation {
    static init(produkt: ProduktDTO): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) => !(ObjectUtils.isNullOrUndefined(newValue) || newValue.length === 0),
                message: { text: ProduktDetailTexts.productDetailHeader.validation.namnRequired },
                model: () => produkt.namn,
                name: "namn",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) => !(ObjectUtils.isNullOrUndefined(newValue) || newValue.length === 0),
                message: { text: ProduktDetailTexts.productDetailHeader.validation.produktgruppRequired },
                model: () => produkt.produktgrupp,
                name: "produktgrupp",
                required: true
            },
            {
                applicable: () => !ObjectUtils.isNullOrUndefined(produkt.beskrivning),
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) => newValue.length < 1000,
                message: { text: ProduktDetailTexts.productDetailHeader.validation.maxLength },
                model: () => produkt.beskrivning,
                name: "beskrivning"
            }
        ]);

        return context;
    }
}
